import jsQR from 'jsqr';

/** Structural subset of DOM `ImageData` — lets this be unit-tested in plain Node (no jsdom needed). */
export interface DecodableImage {
  data: Uint8ClampedArray;
  width: number;
  height: number;
}

/**
 * Pure decode step, kept separate from camera/DOM concerns so it is
 * unit-testable without a browser or camera (see tests/decode.spec.ts).
 */
export function decodeQr(image: DecodableImage): string | null {
  const result = jsQR(image.data, image.width, image.height, {
    inversionAttempts: 'dontInvert',
  });
  return result?.data ?? null;
}
